import React, { useState } from 'react';
import { useParams } from 'react-router';
import { StyledCard } from 'shared/ui/Card/StyledCard';
import { Box, Button, CircularProgress, Stack, Tab, Typography } from '@mui/material';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import { useNavigate } from 'react-router-dom';
import { useDeleteStoryMutation, useGetStoryQuery } from 'features/useStories';
import { TabContext, TabList } from '@mui/lab';
import { MoreInfo } from 'shared/ui/MoreInfo/MoreInfo';
import { isEmptyArr } from 'shared/utils/isEmpty';
import { StoriesFormWidget } from 'widgets/content/ui/StoriesFormWidget';

export const StoriesDetailWidget = () => {
  const [tabValue, setTabValue] = useState('1');
  const { id } = useParams();

  const navigate = useNavigate();
  const cities = useGetCitiesQuery({});
  const countries = useGetCountriesQuery(null);

  const story = useGetStoryQuery({ id });
  const [deleteStory] = useDeleteStoryMutation();

  if (story.isLoading || countries.isLoading || cities.isLoading) {
    return (
      <Stack alignItems="center">
        <CircularProgress />
      </Stack>
    );
  }

  if (story.isError || countries.isError || cities.isError) {
    return <Stack alignItems="center">ERROR</Stack>;
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChangeTabValue = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const onDeleteStory = (id: number) => {
    deleteStory({ id }).then(() => {
      navigate(-1);
    });
  };

  const getCountries = () => {
    if (story.data.countries && countries.data) {
      return countries.data.filter((item) => story.data.countries.includes(item.id)).map((item) => item.name);
    }
    return [];
  };

  const getCities = () => {
    if (story.data.cities && cities.data) {
      return cities.data.filter((item: any) => story.data.cities.includes(item.id)).map((item: any) => item.name);
    }
    return [];
  };

  return story.isSuccess && countries.isSuccess && cities.isSuccess ? (
    <Box
      component={StyledCard}
      sx={{ marginBottom: '24px' }}
    >
      <Box style={{ display: 'flex', marginTop: '24px' }}>
        <div
          className="column"
          style={{ width: '250px', marginTop: 24 }}
        >
          <MoreInfo>
            <div className="title">Направления</div>
            <div className="content">
              {!isEmptyArr(story.data.directions) ? (
                <>{story.data.directions.map((item: any) => item.title).join(', ')}</>
              ) : (
                '---'
              )}
            </div>
          </MoreInfo>
        </div>

        <div
          className="column"
          style={{ width: '250px', marginTop: 24 }}
        >
          <MoreInfo>
            <div className="title">Страны</div>
            <div className="content">{getCountries() ? getCountries().join(', ') : '---'}</div>
          </MoreInfo>
        </div>

        <div
          className="column"
          style={{ width: '250px', marginTop: 24 }}
        >
          <MoreInfo>
            <div className="title">Города</div>
            <div className="content">{getCities() ? getCities().join(', ') : '---'}</div>
          </MoreInfo>
        </div>

        <div
          className="column"
          style={{ width: '250px', marginTop: 24 }}
        >
          <MoreInfo>
            <div className="title">Бренд</div>
            <div className="content">{story.data?.brand_id}</div>
          </MoreInfo>
        </div>
        <div
          className="column"
          style={{ width: '250px', marginTop: 24 }}
        >
          <MoreInfo>
            <div className="title">Приоритет</div>
            <div className="content">{story.data?.priority || '---'}</div>
          </MoreInfo>
        </div>

        <div
          className="column"
          style={{ width: '250px', marginTop: 24 }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 6 }}>
            <Typography variant="h6">{story.data.title}</Typography>

            <Button
              color="error"
              variant="contained"
              onClick={() => onDeleteStory(story.data.id)}
            >
              Удалить
            </Button>
          </Box>
        </div>
      </Box>

      <TabContext value={tabValue.toString()}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            onChange={handleChangeTabValue}
            aria-label="basic tabs example"
          >
            <Tab
              value="1"
              label="RU"
              {...a11yProps(1)}
            />
            <Tab
              value="2"
              label="KZ"
              {...a11yProps(2)}
            />
            <Tab
              value="3"
              label="KG"
              {...a11yProps(3)}
            />
            <Tab
              value="4"
              label="UZ"
              {...a11yProps(4)}
            />
          </TabList>
        </Box>
      </TabContext>

      <Box style={{ display: 'flex', marginTop: '24px' }}>
        {story.data.contents.map(
          (item: any) =>
            +tabValue === item.language_id && (
              <>
                {item && (
                  <div
                    className="column"
                    style={{ width: '250px' }}
                  >
                    <MoreInfo>
                      <div className="title">Фото</div>

                      <div className="content">
                        <Box
                          component="img"
                          src={item.image}
                          sx={{ height: '140px', width: '140px', objectFit: 'cover' }}
                        />
                      </div>
                    </MoreInfo>
                  </div>
                )}

                <div
                  className="column"
                  style={{ width: '500px' }}
                >
                  <MoreInfo>
                    <div className="title">Название</div>
                    <div className="content">{item?.title || '---'}</div>
                  </MoreInfo>
                  <MoreInfo style={{ marginTop: 48 }}>
                    <div className="title">Описание</div>
                    <div className="content">{item?.description || '---'}</div>
                  </MoreInfo>
                </div>
              </>
            ),
        )}

        {story.data.action_buttons.map(
          (item: any) =>
            +tabValue === item.language_id && (
              <div
                className="column"
                style={{ width: '400px' }}
              >
                <MoreInfo>
                  <div className="title">Название кнопки</div>
                  <div className="content">{item?.label || '---'}</div>
                </MoreInfo>
                <MoreInfo style={{ marginTop: 48 }}>
                  <div className="title">URL кнопки</div>
                  <div className="content">{item?.link || '---'}</div>
                </MoreInfo>
              </div>
            ),
        )}
      </Box>

      <StoriesFormWidget
        detail={{ ...story.data, countries_value: getCountries(), cities_value: getCities() }}
        refetch={story.refetch}
      />
    </Box>
  ) : null;
};
